import { render } from "./Mantenimiento.vue?vue&type=template&id=c53b87e6&scoped=true"
import script from "./Mantenimiento.vue?vue&type=script&lang=js"
export * from "./Mantenimiento.vue?vue&type=script&lang=js"

import "./Mantenimiento.vue?vue&type=style&index=0&id=c53b87e6&scoped=true&lang=css"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53b87e6"]])

export default __exports__